module.exports = __webpack_public_path__ + "img/crusher.ec997986.png";